import { savingsOverview } from './overview-config/base';
import { savingsSettingsDetails } from './settings-config/base';

export const savings = {
    settingsDetails: savingsSettingsDetails,
    overview: savingsOverview,
};
